import styled from "styled-components";
import { ButtonBaseStyles, ButtonType, IButtonStyledProps, RightSplitButtonStyles  } from "./Button";

export const LinkButton = styled.a<IButtonStyledProps>`
    ${ButtonBaseStyles};
`

export const RightSplitLinkButton = styled.a<IButtonStyledProps>`
    ${RightSplitButtonStyles};
`

LinkButton.defaultProps = {
    variant: ButtonType.solid
}

RightSplitLinkButton.defaultProps = {
    variant: ButtonType.solid
}